const { getOffsetTop } = window.BAO.Utils

class ParallaxImage extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        transition: transform 0.5s ease;
      }
      :host([active]) {
        transition: transform 0.1s ease;
      }
    `
  }

  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const amountToMoveY = this.dataset.distanceY
      ? parseFloat(this.dataset.distanceY)
      : window.BAO.MediaBreakpoints.isXsViewport
        ? 30
        : 100
    const elementHeight = this.offsetHeight

    const scaleAmount = amountToMoveY / elementHeight + 1

    const scaledItemHeight = elementHeight + amountToMoveY
    const heightDifference = scaledItemHeight - elementHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY /
        -2}px, 0px) scale(${scaleAmount})`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY /
        2}px, 0px) scale(${scaleAmount})`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

    this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px) scale(${scaleAmount})`
  }
}

if (!customElements.get('parallax-image')) {
  customElements.define('parallax-image', ParallaxImage)
}
